import { Inject, Injectable, InjectionToken } from '@angular/core';
import { BusinessUnit, ImagingOpenParams, Patient } from 'estensa-module';
import { noop } from 'lodash-es';

export const BROKER_MODULE_BROKER_CHECK_SERVICE = new InjectionToken('broker.module.broker.check.service');

export interface BrokerExamination {
    id: string;
    accessionNumber: string;
    patient: Patient;
    businessUnit: BusinessUnit;
}

export interface IBrokerCheckServiceNg1 {
    openImagesByVnaItems(vnaItems, credentials, openParams: ImagingOpenParams);
    openImagesByExaminations(
        idIs: number,
        examinations: BrokerExamination[],
        isLocked: boolean,
        isInteractive: boolean,
        openParams: ImagingOpenParams
    );
    openImagesByEprEvent(eprEvent, credentials, openParams: ImagingOpenParams);
}

@Injectable()
export class NullBrokerCheckService implements IBrokerCheckServiceNg1 {
    openImagesByVnaItems = noop;
    openImagesByExaminations = noop;
    openImagesByEprEvent = noop;
}

@Injectable({
    providedIn: 'root',
})
export class BrokerCheckService implements IBrokerCheckServiceNg1 {
    constructor(@Inject(BROKER_MODULE_BROKER_CHECK_SERVICE) private brokerCheckService: IBrokerCheckServiceNg1) { }

    openImagesByVnaItems(vnaItems, credentials, openParams: ImagingOpenParams) {
        return this.brokerCheckService.openImagesByVnaItems(vnaItems, credentials, openParams);
    }

    openImagesByEprEvent(eprEvent /*EstensaModel.RadioEprEvent[]*/, credentials, openParams: ImagingOpenParams) {
        return this.brokerCheckService.openImagesByEprEvent(eprEvent, credentials, openParams);
    }

    openImagesByExaminations(
        idIs: number | null,
        examinations: BrokerExamination[],
        isLocked: boolean,
        isInteractive: boolean,
        openParams: ImagingOpenParams
    ) {
        return this.brokerCheckService.openImagesByExaminations(
            idIs,
            examinations,
            isLocked,
            isInteractive,
            openParams
        );
    }
}
